import globalComponentsStore from '../store/global-components.js'

const componentGlobalSaver = {
  save: function (Vue, Component) {
    globalComponentsStore.components[Component.name] = Component
  },
  registerGlobalAndSave: function (Vue, Component) {
    Vue.component(Component.name, Component)
    this.save(Vue, Component)
  },
  restore: function (componentName, inContext = null) {
    return globalComponentsStore.components[componentName] || null
  }
}

export default componentGlobalSaver
